import { CircularProgress } from '@material-ui/core';
import { t } from 'i18next';
import React, { ReactNode } from 'react';
import { isMobile } from 'shared/util/utility';

export interface DialogCardProps {
	className?: string;
	icon?: React.FC;
	iconNode?: ReactNode;
	children?: ReactNode;
	iconTitle?: any;
	iconTitleClass?: string;
	subDescription?: any;
	subDescriptionClass?: string;
	title?: string;
	titleClass?: string;
	subTitle?: JSX.Element | string;
	subTitleClass?: string;
	cardBottomClass?: string;
	cardBottomText?: any;
	cardBottomCustom?: JSX.Element;
	showAmount?: boolean;
	iconClass?: string;
	disable?: boolean;
	loading?: boolean;
	onActionButtonClick?: (e: any) => void;
	cyActionTextRef?: string;
	cyDescriptionTestRef?: string;
}

const DialogCard = (props: DialogCardProps) => {
	const {
		className,
		loading,
		iconTitle,
		iconTitleClass,
		subDescription,
		subDescriptionClass,
		title,
		titleClass,
		subTitle,
		subTitleClass,
		cardBottomClass,
		cardBottomText,
		showAmount,
		iconClass,
		cardBottomCustom,
		iconNode = null,
		cyActionTextRef,
		cyDescriptionTestRef,
	} = props;
	return (
		<div className={`dialog-card ${className ? className : ''}`}>
			<div className={`card__icon ${iconClass ? iconClass : ''}`}>
				{!!props.icon && <props.icon />}
				{iconNode}
				{iconTitle && (
					<p className={`icon--title ${iconTitleClass ? iconTitleClass : ''} mt--10 mb--0 line-height--21`} data-cy={cyDescriptionTestRef}>
						{typeof iconTitle === 'string' ? iconTitle : iconTitle()}
					</p>
				)}
			</div>
			{subDescription || title || showAmount || subTitle || props.children ? (
				<div className="card__body">
					{subDescription && (
						<p
							className={`card--sub-description ${
								subDescriptionClass ? subDescriptionClass : ''
							} mt--0 mb--5 font--regular font-size--sm line-height--20`}
						>
							{typeof subDescription === 'string' ? subDescription : subDescription()}
						</p>
					)}
					{title && showAmount && (
						<span
							className={`card--title ${titleClass ? titleClass : ''} mb--0 mt--0 font--bold ${
								title.length > 7 ? 'font-size--33' : 'font-size--40'
							} break__word--word`}
						>
							{t('Common_currency', { val: title })}
						</span>
					)}

					{title && !showAmount && (
						<span
							className={`card--title ${titleClass ? titleClass : ''} mb--0 mt--0 font--bold ${
								isMobile() ? 'font-size--26' : 'font-size--35'
							}`}
						>
							{title}
						</span>
					)}
					{subTitle && (
						<span className={`card--sub-title ${subTitleClass ? subTitleClass : ''} font--regular font-size--sm line-height--20`}>
							{subTitle}
						</span>
					)}
					{props.children}
				</div>
			) : null}
			{!cardBottomCustom ? (
				<div
					className={`card__bottom ${cardBottomClass ? cardBottomClass : ''} ${loading ? 'bottom-loading' : ''}`}
					onClick={(e) => {
						if (!props.disable && props.onActionButtonClick) props.onActionButtonClick(e);
					}}
					data-cy={cyActionTextRef}
				>
					{loading && <CircularProgress color="primary" size="30px" />}
					{!loading && cardBottomText && (
						<p className={`font-size--sm no--margin font--bold line-height--20`}>
							{typeof cardBottomText === 'string' ? cardBottomText : cardBottomText()}
						</p>
					)}
				</div>
			) : (
				cardBottomCustom
			)}
		</div>
	);
};

export default DialogCard;
